// extracted by mini-css-extract-plugin
var _1 = "CardHeader-module__aboveTitle--bq0Jq";
var _2 = "CardHeader-module__animateUploadProgressBarWidth--NT2eg";
var _3 = "CardHeader-module__animatedBackground--BCZK3";
var _4 = "CardHeader-module__container--xOueY";
var _5 = "CardHeader-module__icon--aq3I4";
var _6 = "CardHeader-module__meta--ZN2ZH";
var _7 = "CardHeader-module__rightAction--bvcxi";
var _8 = "CardHeader-module__rightMeta--IESF3";
var _9 = "CardHeader-module__title--nDIY3";
export { _1 as "aboveTitle", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "icon", _6 as "meta", _7 as "rightAction", _8 as "rightMeta", _9 as "title" }
